// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WeiboCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/WeiboCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var WeiboCircleOutlined = function WeiboCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WeiboCircleOutlinedSvg
  }));
};

WeiboCircleOutlined.displayName = 'WeiboCircleOutlined';
export default React.forwardRef(WeiboCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/WeiboCircleOutlined.js
// module id = 2057
// module chunks = 0